import type { ChatUser } from '../../../types/chat'
import { getAvailabilityCalendarFromSettings } from '@shared/availability/parse'
import { getProviderActivityStatus } from '../../provider-activity/activity-status'
import type { TransferTargetContext } from '@shared/calls/transfer-eligibility'

/** Build transfer eligibility context from a directory user + optional session state. */
export function buildTransferTargetContext(
  user: ChatUser,
  opts?: {
    onActiveCall?: boolean
    sessionLifecycleState?: string | null
  },
): TransferTargetContext {
  const activity = getProviderActivityStatus(user)
  return {
    userId: user.userId,
    displayName: user.displayName,
    presence: user.presenceStatus ?? undefined,
    activityPresetId: activity?.presetId ?? null,
    pauseNotifications: activity?.pauseNotifications ?? false,
    onActiveCall: opts?.onActiveCall ?? false,
    sessionLifecycleState: opts?.sessionLifecycleState ?? null,
    availabilityCalendar: getAvailabilityCalendarFromSettings(user.settingsJson),
  }
}
